'use client';

import { c as _c } from "react/compiler-runtime";
import WorldActionButtons from '@/app/[locale]/(worlds)/[roomId]/components/WorldActionButtons';
import WorldMobileActionButtons from '@/app/[locale]/(worlds)/[roomId]/components/WorldMobileActionButtons';
import WorldPlayButtonMobile from '@/app/[locale]/(worlds)/[roomId]/components/WorldPlayButtonMobile';
import WorldReportModal from '@/app/[locale]/(worlds)/[roomId]/components/WorldReportModal';
import ReportConfirmationModal from '@/components/ReportConfirmationModal';
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext';
import { useWorldDetailsContext } from '@/context/WorldDetailsContext';
import { useState } from 'react';
export default function WorldMobileTitleArea() {
  const $ = _c(17);
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [isReportSuccessOpen, setIsReportSuccessOpen] = useState(false);
  const {
    showMobilePlayButton
  } = useWorldDetailsContext();
  const {
    roomData
  } = useCheckEnterRoomContext();
  const playLabelKey = roomData.content_type?.code === "experiences" ? "world-info.launch" : "world-info.play-game";
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <WorldMobileActionButtons onReport={() => setIsReportModalOpen(true)} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== playLabelKey) {
    t1 = <WorldPlayButtonMobile buttonClassName="bg-vive-brand-50 h-12 py-3 text-[18px] leading-[22px] font-semibold tracking-[0.2px] landscape:w-[358px]" className="flex flex-col gap-4" playLabelKey={playLabelKey} showPlayIcon={false} trailingContent={t0} />;
    $[1] = playLabelKey;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsReportModalOpen(false);
    t3 = () => setIsReportSuccessOpen(true);
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isReportModalOpen) {
    t4 = <WorldReportModal isDialogOpen={isReportModalOpen} onClose={t2} onReportSuccess={t3} />;
    $[5] = isReportModalOpen;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setIsReportSuccessOpen(false);
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== isReportSuccessOpen) {
    t6 = <ReportConfirmationModal open={isReportSuccessOpen} onAction={t5} />;
    $[8] = isReportSuccessOpen;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== showMobilePlayButton) {
    t7 = !showMobilePlayButton && <WorldActionButtons className="items-center" />;
    $[10] = showMobilePlayButton;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t1 || $[13] !== t4 || $[14] !== t6 || $[15] !== t7) {
    t8 = <>{t1}{t4}{t6}{t7}</>;
    $[12] = t1;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}